import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Chat.scss";

type BannerType = "private" | "weeklyCheckin";

interface Props {
  readonly type: BannerType;
  readonly customMessage?: string;
}

export default function ChatInfoBanner({ type, customMessage }: Props) {
  if (type === "weeklyCheckin") {
    return (
      <div className="warning-banner gold row-gap-16px align-items-center chat-info-banner__container chat-info-banner__container--weekly-checkin">
        <FontAwesomeIcon
          icon={["far", "eye"]}
          className="chat-info-banner__icon chat-info-banner__icon--warning"
        />
        <p>
          {customMessage ||
            "Note: Your responses will be summarized and shared with your manager and company leaders."}
        </p>
      </div>
    );
  }

  return (
    <div className="warning-banner light-green row-gap-16px align-items-center chat-info-banner__container chat-info-banner__container--private">
      <FontAwesomeIcon
        icon={["far", "eye-slash"]}
        className="chat-info-banner__icon chat-info-banner__icon--private"
      />
      <p className="chat-info-banner__text chat-info-banner__text--private">
        {customMessage || (
          <>
            This chat is <b>completely anonymous</b>. Your chat history will not
            be shared with anyone else.
          </>
        )}
      </p>
    </div>
  );
}
